import { rem } from 'polished';
import styled from 'styled-components';

export const HideByScreenWidth = styled.div<{
  minWidth: number;
}>`
  @media only screen and (max-width: ${({ minWidth }) => rem(minWidth)}) {
    display: none;
  }
`;
